package com.wintermar.inspection.feature.presentation.inspection.complete.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.answer.SummaryAnswerModel
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.feature.presentation.inspection.complete.widget.page_info.PageInfoSideMenu

@Composable
actual fun InspectionCompleteContent(
    data: InspectionModel,
    flaggedItems: List<SummaryAnswerModel>,
    templateOptions: List<TemplateOptionModel>,
    listState: LazyListState,
    paddingValues: PaddingValues,
    onClickPage: (page: String) -> Unit
) {
    val dimension: AppDimension = LocalAppTheme.current.dimension
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                horizontal = dimension.spacing.space7
            ),
        horizontalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space8
        )
    ) {
        Column(
            modifier = Modifier.weight(0.3f)
        ) {
            PageInfoSideMenu(
                flaggedItems = flaggedItems,
                onClick = onClickPage
            )
        }

        Column(
            modifier = Modifier.weight(0.7f)
        ) {
            InspectionCompleteView(
                showOverviewBorder = true,
                data = data,
                flaggedItems = flaggedItems,
                templateOptions = templateOptions,
                listState = listState,
                paddingValues = paddingValues
            )
        }
    }
}
